<template>
  <v-container
    id="intro"
    tag="section"
  >
    <v-row class="mt-5">
      <v-col cols="2" offset="5" align="center" justify="center">
        <v-img
          :src="require(`@/assets/articles/xterra-surface-logo.png`)"
          width="75%"
        >
        </v-img>
      </v-col>
    </v-row>

    <base-subheading><h1 class="text-center mt-5" style="font-family: 'Montserrat Subrayada', sans-serif; font-size: 1.5em;">XTERRA SURFACE</h1><h6 class="text-center font-weight-light" style="font-family:Montserrat"><i>Design, Perfection & Quality ™</i></h6></base-subheading>
    <hr>
    
  </v-container>
</template>

<script>
  export default {
    name: 'HomeIntro',
  }
</script>
